import { Tag, Spinner } from "@chakra-ui/react";
import * as React from "react";
import type { SpinnerProps } from "@chakra-ui/react";

export interface ProcessStateTagProps extends Tag.RootProps {
  state: string;
  spinnerProps?: SpinnerProps;
}

export const ProcessStateTag = React.forwardRef<
  HTMLSpanElement,
  ProcessStateTagProps
>(function ProcessStateTag({ state, spinnerProps, ...rest }, ref) {
  const map: Record<
    string,
    {
      label: string;
      colorPalette: Tag.RootProps["colorPalette"];
      showSpinner?: boolean;
    }
  > = {
    IDLE: { label: "대기", colorPalette: "blue" },
    IN_PROGRESS: { label: "진행중", colorPalette: "yellow", showSpinner: true },
    IN_ANALYSIS: { label: "분석중", colorPalette: "yellow", showSpinner: true },
    ANALYSIS_FINISHED: { label: "분석완료", colorPalette: "purple" },
    FINISHED: { label: "완료", colorPalette: "green" },
    FAILED: { label: "실패", colorPalette: "red" },
    // 하위 호환성을 위한 소문자 매핑
    idle: { label: "대기", colorPalette: "blue" },
    in_progress: { label: "진행중", colorPalette: "yellow", showSpinner: true },
    in_analysis: { label: "분석중", colorPalette: "yellow", showSpinner: true },
    analysis_finished: { label: "분석완료", colorPalette: "purple" },
    finished: { label: "완료", colorPalette: "green" },
    failed: { label: "실패", colorPalette: "red" },
  };

  const { label, colorPalette, showSpinner } = map[state] ?? {
    label: "Unknown",
    colorPalette: "gray",
  };

  return (
    <Tag.Root
      ref={ref}
      size="sm"
      colorPalette={colorPalette}
      variant="subtle"
      {...rest}
    >
      {showSpinner ? (
        <>
          <Tag.Label>{label}</Tag.Label>
          <Tag.StartElement display="flex" alignItems="center">
            <Spinner size="xs" {...spinnerProps} />
          </Tag.StartElement>
        </>
      ) : (
        <Tag.Label>{label}</Tag.Label>
      )}
    </Tag.Root>
  );
});
